export default "__VITE_ASSET__BM_DwmR2__"